<template>
  <div class="container mt-5 spa-cal">
    <vue-cal ref="vueCal" @view-change="onViewChange" :events="events" :default-view="'month'"
      events-on-month-view="full" :locale="'zh-hk'" :disable-views="['years', 'year', 'week', 'day']"
      @cell-click="showConfirmDate">
      <template #cell-content="{ cell, view, events }">
        <div :class="[
          'my-cell',
          isSelected(cell.formattedDate) ? 'my-highlight' : '',
          isPastDate(cell.formattedDate) ? 'is-past' : ''
        ]">
          <div class="date-number">
            {{ new Date(cell.formattedDate).getDate() }}
          </div>
          <div v-for="event in events" :key="event.id" class="event-title">
            {{ event.title }}
          </div>
        </div>
      </template>
    </vue-cal>
    <b-modal ref="confirm-date" hide-footer hide-header>
      <div class="d-flex justify-content-end">
        <b-icon icon="x-circle-fill" style="color: #ec6c01; cursor: pointer" @click="hideConfirmDate"></b-icon>
      </div>
      <div class="center column">
        <div class="orange bold f24">請確認您所選的日期正確無誤</div>
        <div class="bold mt-4 f22">{{ startDate }} ~ {{ endDate }}</div>
        <button type="button" class="orange-btn mt-4 w-100 p-2 f24" @click="toReserved">
          確定
        </button>
        <button type="button" class="btn btn-light mt-3 w-100 f24" style="border: 1px solid black"
          @click="hideConfirmDate">
          取消
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { VueCal } from 'vue-cal';
import 'vue-cal/dist/vuecal.css';
import moment from 'moment';
import 'moment/locale/zh-tw';

export default {
  data() {
    return {
      events: [],
      startDate: null,
      endDate: null,
      selectedDates: [],
      SpaData: {},
      IS_ON_FIRST_PAGE: false
    };
  },
  created() {
    var savedData = localStorage.getItem('spa_data');
    this.SpaData = JSON.parse(savedData);
  },
  mounted() {
    setTimeout(() => {
      if (this.$refs.vueCal && this.$refs.vueCal.view) {
        this.onViewChange(this.$refs.vueCal.view);
      }
    }, 0);
    window.addEventListener("message", this.handleMessage);
  },
  beforeDestroy() {
    window.removeEventListener("message", this.handleMessage);
  },
  methods: {
    handleMessage(event) {
      console.log("Received message event:", event);
      console.log("Message data:", event.data);

      if (event.data === "backButtonClick") {
        if (this.IS_ON_FIRST_PAGE) {
          parent.postMessage("goToHome", "*");
        } else {
          // Vue Router 返回上一頁
          this.$router.back();
        }
      }
    },
    GetSpaCalendar(start, end) {
      var FormDate = moment(start).format('YYYY/MM/DD');
      var ToDate = moment(end).format('YYYY/MM/DD');
      var post_data = {
        searchData: this.$Global.Base64Utils.utoa(
          JSON.stringify({
            ShopNO: this.$Global.Base64Utils.atou(
              this.$cookieFunc.getCookie('ShopNO')
            ),
            Flowno: this.SpaData.Flowno,
            SnB: this.SpaData.SnB,
            SnC: this.SpaData.SnC
          })
        ),
        FromDate: FormDate,
        ToDate: ToDate
      };

      this.$axios({
        method: 'post',
        url: this.$URLJson.GetSpaCalendar,
        data: post_data
      })
        .then((res) => {
          var decoded = this.$Global.Base64Utils.atou(res.data);
          var parsed = JSON.parse(decoded);
          var apiEvents = JSON.parse(parsed.data);
          this.events = apiEvents.filter(
            (event) =>
              event.title === '預約已滿' || event.title === '無可預約時段'
          );
          // this.events = JSON.parse(parsed.data);

          console.log(this.events);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    toReserved() {
      var confirmData = {
        start: this.startDate,
        end: this.endDate,
        Flowno: this.SpaData.Flowno,
        SnB: this.SpaData.SnB,
        SnC: this.SpaData.SnC
      };
      localStorage.setItem('confirm_data', JSON.stringify(confirmData));
      this.$router.push({ name: 'SpaReserved' });
    },
    getDateRange(start, end) {
      var range = [];
      let current = new Date(start);

      while (current <= new Date(end)) {
        range.push(this.formatDate(current));
        current.setDate(current.getDate() + 1);
      }

      return range;
    },

    formatDate(date) {
      var yyyy = date.getFullYear();
      var mm = String(date.getMonth() + 1).padStart(2, '0');
      var dd = String(date.getDate()).padStart(2, '0');
      return `${yyyy}-${mm}-${dd}`;
    },

    isSelected(date) {
      return this.selectedDates.includes(date);
    },

    isPastDate(dateStr) {
      var today = new Date();
      today.setHours(0, 0, 0, 0);
      var date = new Date(dateStr);
      return date < today;
    },

    onViewChange(view) {
      const currentMonthStart = new Date(view.startDate);

      // 禁用「上一個月」按鈕
      const monthFirstDay = new Date();
      monthFirstDay.setDate(1);

      const prevArrow = document.querySelector('.vuecal__arrow--prev');
      if (!prevArrow) return;

      if (currentMonthStart <= monthFirstDay) {
        prevArrow.classList.add('disabled-prev');
      } else {
        prevArrow.classList.remove('disabled-prev');
      }
      const today = new Date();

      this.GetSpaCalendar(today, view.lastCellDate);
    },

    showConfirmDate(dateObj) {
      var clickedDate = this.formatDate(dateObj);
      if (this.isPastDate(clickedDate)) return;
      if (!this.startDate || (this.startDate && this.endDate)) {
        this.startDate = clickedDate;
        this.endDate = null;
        this.selectedDates = [clickedDate];
      } else if (!this.endDate) {
        this.endDate = clickedDate;
        if (this.startDate > this.endDate) {
          [this.startDate, this.endDate] = [this.endDate, this.startDate];
        }
        this.selectedDates = this.getDateRange(this.startDate, this.endDate);
        this.$refs['confirm-date'].show();
      }
    },

    hideConfirmDate() {
      this.$refs['confirm-date'].hide();
      this.startDate = '';
      this.endDate = '';
      this.selectedDates = [];
    }
  }
};
</script>

<style scoped>
.spa-cal /deep/ .vuecal__cell-content {
  width: 30px;
  height: 150px;
}

.spa-cal /deep/ .vuecal__event-title {
  display: none;
}

.spa-cal /deep/ .vuecal__cell--out-of-scope {
  visibility: hidden;
  /* 隱藏整個格子內容 */
  pointer-events: none;
  /* 防止點擊 */
  background: #f9f9f9;
  /* 可選：填充背景避免空白 */
}

.my-cell {
  width: 100%;
  height: 100%;
  font-size: 1.5rem;
  color: #e27814;
  font-weight: 600;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.date-number {
  margin-bottom: 4px;
}

.event-title {
  color: #ee1a26;
  font-weight: bold;
  font-size: 1.3rem;
}

.my-highlight {
  background-color: rgba(255, 165, 0, 0.4);
}
</style>

<style>
.vuecal__menu {
  display: none !important;
}

/* .vuecal__cell-date {
  font-size: 1.5rem;
  color: #e27814;
  font-weight: 600;
} */

.vuecal__cell--out-of-scope .vuecal__cell-date {
  color: #ccc;
}

.vuecal__event-time {
  display: none;
}

.weekday-label {
  color: #e27814;
}

.vuecal__title-bar {
  background-color: #e0d2d2;
}

.vuecal__title button {
  pointer-events: none;
}

.list-group-item {
  text-align: left;
  font-size: 1.5rem;
}

.vuecal__cell,
.weekday-label {
  background-color: white;
}

.list-group-title {
  font-size: 1rem;
  font-weight: bold;
}

.is-past {
  background-color: #f0f0f0;
  color: #aaa !important;
}

.vuecal__arrow--prev.disabled-prev {
  opacity: 0.3;
  pointer-events: none;
}
</style>



// WEBPACK FOOTER //
// src/components/View/Spa/SpaCalendar.vue